module.exports = function isSmallScreen() {
  return window.innerWidth < 600;
}